import { http } from '@/app/lib/http/client'

export interface BankItem {
    id: number
    company_id: number
    name: string
    code: string
    is_active: boolean
    created_at?: string
    updated_at?: string
}

export interface CreateBankPayload {
    name: string
    is_active?: boolean
}

export interface UpdateBankPayload {
    name?: string
    is_active?: boolean
}

export const banksService = {
    async getItems(params?: { per_page?: number; search?: string; page?: number, is_active?: boolean, all?: boolean }) {
        const response = await http.get('/banks', { params })
        return response.data
    },

    async getItem(id: number) {
        const response = await http.get(`/banks/${id}`)
        return response.data
    },

    async createItem(payload: CreateBankPayload) {
        const response = await http.post('/banks', payload)
        return response.data
    },

    async updateItem(id: number, payload: UpdateBankPayload) {
        const response = await http.put(`/banks/${id}`, payload)
        return response.data
    },

    async toggleStatus(id: number) {
        const response = await http.patch(`/banks/${id}/status`)
        return response.data
    },

    async deleteItem(id: number) {
        const response = await http.delete(`/banks/${id}`)
        return response.data
    },
}
